module.exports = __webpack_public_path__ + "img/speaker.be51ca92.png";